const FRAGMENT_REPORT_FIELDS = `fragment ReportFields on Report {
  id,
  created,
  updated,
  subject,
  topics,
  reportTemplateId,
  memberId,
  site,
  shared,
  title
}`

const UPDATE_REPORT_BY_ID = `mutation UpdateReportTopics($id: UUID!, $topics: JSON!, $title: String!) {
  updateReportById (input: {
      id: $id,
      reportPatch: {
        topics: $topics
        title: $title
      }
    }) {
      report {
        ...ReportFields
      }
    }
}

${FRAGMENT_REPORT_FIELDS}`;

const UPDATED_REPORT_SHARED = `mutation UpdateReportSharedStatus($id: UUID!, $shared: Boolean!) {
updateReportById (input: {
    id: $id,
    reportPatch: {
      shared: $shared
    }
  }) {
    report {
      ...ReportFields
    }
  }
}

${FRAGMENT_REPORT_FIELDS}`;

export class ReportAPI {
    constructor() {
        this.resolvedAuthHeader = null;
    }

    /**
   * @param report
   * @returns {Promise<any>}
   */
  saveReport({id, topics, title}) {
    return ENVIRONMENT.graphQLClient()
      .then(client => client.request(UPDATE_REPORT_BY_ID, {id, topics, title}))
  }

  updateReportShared({id}, shared) {
    return ENVIRONMENT.graphQLClient()
      .then(client => client.request(UPDATED_REPORT_SHARED, {id, shared}))
  }

  /**
   *
   * @param {string} reportId
   * @returns {Promise<Response>}
   */
  async enqueueReportPDF (reportId, signal = undefined) {
    const headers = await ENVIRONMENT.authHeader();

    const response = await fetch(
        `/reportApi/api/v1/report/pdf/${reportId}`,
        {
          credentials: "include",
          headers,
          signal
        }
    );

    if (response.ok) {
        return response;
    }

    throw new Error(`Response not OK: ${response.status} ${response.statusText}`);
  }

  async fetchReportPDF (reportPDFId, signal = undefined) {
    this.resolvedAuthHeader = this.resolvedAuthHeader || await ENVIRONMENT.authHeader();

    const response = await fetch(
        `/reportApi/api/v1/report/pdf-job/${reportPDFId}`,
        {
          credentials: "include",
          headers: this.resolvedAuthHeader,
          signal
        }
    );

    if (response.ok) {
      return response;
      /*if (response.headers.get('Content-Type').includes('application/pdf')) {
        return response.blob();
      }*!/
      return response.json();*/
    }

    throw new Error(`Response not OK: ${response.status} ${response.statusText}`);
  }
}
